import updateUserConfiguration from 'owa-session-store/lib/services/updateUserConfiguration';
import userConfigurationDictionaryEntry from 'owa-service/lib/factory/userConfigurationDictionaryEntry';
import userConfigurationDictionaryObject from 'owa-service/lib/factory/userConfigurationDictionaryObject';

export async function saveDensityModeFromFullSettingsService(newDensityModeValue: number) {
    // From full settings, only message height will be updated
    updateUserConfiguration('OWA.UserOptions', [
        userConfigurationDictionaryEntry({
            DictionaryKey: userConfigurationDictionaryObject({
                Type: 'String',
                Value: ['DisplayDensityMode'],
            }),
            DictionaryValue: userConfigurationDictionaryObject({
                Type: 'Integer32',
                Value: [String(newDensityModeValue)],
            }),
        }),
    ]);
}

export async function saveDensityModeFromQuickSettingsService(
    newDensityModeValue: number,
    isInlinePreviewEnabled: boolean,
    listViewBitFlagsValue: number
) {
    // From quick settings, update message height and update attachment preview and sender image, date header features
    updateUserConfiguration('OWA.UserOptions', [
        userConfigurationDictionaryEntry({
            DictionaryKey: userConfigurationDictionaryObject({
                Type: 'String',
                Value: ['DisplayDensityMode'],
            }),
            DictionaryValue: userConfigurationDictionaryObject({
                Type: 'Integer32',
                Value: [String(newDensityModeValue)],
            }),
        }),
        userConfigurationDictionaryEntry({
            DictionaryKey: userConfigurationDictionaryObject({
                Type: 'String',
                Value: ['ShowInlinePreviews'],
            }),
            DictionaryValue: userConfigurationDictionaryObject({
                Type: 'Boolean',
                Value: [String(isInlinePreviewEnabled)],
            }),
        }),
    ]);

    updateUserConfiguration('OWA.ViewStateConfiguration', [
        userConfigurationDictionaryEntry({
            DictionaryKey: userConfigurationDictionaryObject({
                Type: 'String',
                Value: ['ListViewBitFlags'],
            }),
            DictionaryValue: userConfigurationDictionaryObject({
                Type: 'Integer32',
                Value: [String(listViewBitFlagsValue)],
            }),
        }),
    ]);
}
